export const STRIPE_CONNECT_REQUIRED_CAPABILITIES = ['card_payments', 'transfers'];

// Sharetribe forwards these values to Stripe Account Links. Use Stripe's
// current hosted onboarding/update link types so missing payout details are
// collected by Stripe instead of sending sellers to an old verification screen.
export const STRIPE_CONNECT_ONBOARDING_LINK_TYPE = 'account_onboarding';
export const STRIPE_CONNECT_UPDATE_LINK_TYPE = 'account_update';

export const STRIPE_EXTERNAL_ACCOUNT_REQUIREMENT = 'external_account';

// Up-front hosted onboarding asks Stripe to collect all currently/eventually due
// requirements, including external_account when Stripe Connect payout onboarding
// settings allow Stripe-hosted collection. Tutulist must not collect or store
// bank account details itself.
// If Stripe still shows only a summary while external_account is due, check
// Stripe Dashboard > Connect settings > Payout onboarding / External account
// settings and enable external account collection for connected accounts.
export const STRIPE_CONNECT_ONBOARDING_COLLECTION_OPTIONS = {
  fields: 'eventually_due',
  future_requirements: 'include',
};
